module.exports = __webpack_public_path__ + "static/img/bg3.3c5e5501.jpg";